import { Model } from '@vuex-orm/core'
import Station from './Station'
import JourneyLeg from './JourneyLeg'

export default class CallingPoint extends Model {
  static entity = 'callingPoints'

  static fields() {
    return {
      id: this.increment(),
      leg_id: this.attr(),
      station_id: this.attr(),
      leg: this.belongsTo(JourneyLeg, 'leg_id'),
      station: this.belongsTo(Station, 'station_id'),
      scheduled_departure: this.attr(''),
      scheduled_arrival: this.attr(''),
      indicator: this.attr(''),
    }
  }
}
